import { uniqueId } from "lodash"
import { useRef } from "react"

function useUniqueId(prefix: string = "t_") {
  const uniqueIdRef = useRef(uniqueId(prefix))
  return uniqueIdRef.current
}

export default useUniqueId
